import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
const BusinessMatchForm = ({
  sfFields,
  showMatchForm,
  showMatchText,
  setShowMatchForm,
}) => {
  const [propertyNumber, setPropertyNumber] = useState(0);
  const [ownershipType, setOwnershipType] = useState();
  const [pointOfSales, setPointOfSales] = useState();
  const [managedNetworkSwitch, setManagedNetworkSwitch] = useState();

  return (
    <>
      {showMatchText && (
        <div className="form-margin-center">
          <div className="form-show-more modular-p">
            <button
              type="button"
              className="square-button-black"
              onClick={() => setShowMatchForm(!showMatchForm)}
            >
              Help us match you to the best product
            </button>{' '}
            <div
              className={`${
                showMatchForm ? 'form-arrow-rotate' : 'form-arrow'
              }`}
            >
              <FontAwesomeIcon icon={faChevronDown} />
            </div>
          </div>{' '}
          {!showMatchForm && (
            <button className="Black-button-underline">
              {' '}
              or skip and register now
            </button>
          )}
        </div>
      )}
      {showMatchForm && (
        <>
          <div className="form-input-container" style={{ alignItems: 'end' }}>
            <div className="form-input-inner column-1 form-label-visible">
              <label for={sfFields.numberStaff}>Number of staff</label>
              <div className="form-select-arrow">
                <select
                  id={sfFields.numberStaff}
                  name={sfFields.numberStaff}
                  title="Number of staff?"
                >
                  <option value="">--None--</option>
                  <option value="1-10">1-10</option>
                  <option value="11-50">11-50</option>
                  <option value="50-100">50-100</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>{' '}
            <div className="form-input-inner column-3 form-label-visible">
              <label for={sfFields.itExpertise}>Level of IT Expertise</label>
              <div className="form-select-arrow">
                <select id={sfFields.itExpertise} name={sfFields.itExpertise}>
                  <option value="">--None--</option>
                  <option value="I'm a technophobe">I'm a technophobe</option>
                  <option value="I need help setting things up">
                    I need help setting things up
                  </option>
                  <option value="I'm somewhat confident">
                    I'm somewhat confident
                  </option>
                  <option value="I have my own IT team">
                    I have my own IT team
                  </option>
                </select>
              </div>
            </div>
            <div className="form-input-inner column-1 form-label-visible">
              <label for={sfFields.numberProperties}>
                How many properties?
              </label>
              <input
                id={sfFields.numberProperties}
                name={sfFields.numberProperties}
                type="number"
                max={10}
                placeholder="Enter number of business properties owned"
                onChange={(e) => setPropertyNumber(e.target.value)}
              />
            </div>
            <div className="form-input-inner column-3 form-label-visible">
              <label for={sfFields.independantBusiness}>
                What is the ownership type of the properties?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.independantBusiness}
                  id={sfFields.independantBusiness}
                  onChange={(e) =>
                    setOwnershipType(e.target.value === 'Independant')
                  }
                >
                  <option value="">--None--</option>
                  <option value="Independent">Independent</option>
                  <option value="Part of a chain">Part of a chain</option>
                </select>
              </div>
            </div>
            {ownershipType && (
              <div className="form-input-inner column-1 form-label-visible">
                <label for={sfFields.accountHolderAlwaysOnSite}>
                  Is the owner or manager always on site?
                </label>
                <div className="form-select-arrow">
                  <select
                    name={sfFields.accountHolderAlwaysOnSite}
                    id={sfFields.accountHolderAlwaysOnSite}
                  >
                    <option value="">--None--</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            )}
            {/* <div className="form-input-inner column-1 form-label-visible">
          <label for="">Are you VAT Registered?</label>
          <div className="form-select-arrow">
            <select name={sfFields.vatRegistered} id={sfFields.vatRegistered}>
              <option value="">--None--</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div> */}
            <div className="form-input-inner column-3 form-label-visible">
              <label for={sfFields.cutomerTimeOnPremises}>
                How much time does the customer spend on the premises?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.cutomerTimeOnPremises}
                  id={sfFields.cutomerTimeOnPremises}
                >
                  <option value="">--None--</option>
                  <option value="1-5 mins">1-5 mins</option>
                  <option value="5-20 mins">5-20 mins</option>
                  <option value="20-60 mins">20-60 mins</option>
                  <option value="60+ mins">60+ mins</option>
                </select>
              </div>
            </div>
            <div className="form-margin-center-large column-span">
              <div className="form-heading">
                <h3 className="yellow-text">
                  ...and a little about your technology too.
                </h3>
              </div>
              <p>
                At Lit Fibre, we're here to bring you the right solution for
                your business. To help us tailor our service to your needs,
                please take a moment to answer a few quick questions.
              </p>
            </div>
            <div className="form-input-inner column-1 form-label-visible">
              <label for={sfFields.primarySecondaryConnection}>
                Are you looking to purchase as a primary of secondary
                Connection?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.primarySecondaryConnection}
                  id={sfFields.primarySecondaryConnection}
                >
                  <option value="">--None--</option>
                  <option value="Primary">Primary</option>
                  <option value="Secondary">Secondary</option>
                </select>
              </div>
            </div>
            <div className="form-input-inner column-3 form-label-visible">
              <label for={sfFields.posSystem}>
                Do you have a point of sales system?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.posSystem}
                  id={sfFields.posSystem}
                  onChange={(e) => setPointOfSales(e.target.value === 'Yes')}
                >
                  <option value="">--None--</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            {pointOfSales && (
              <div className="form-input-inner column-3 form-label-visible">
                <label for={sfFields.posSystemType}>
                  What is the connection type of your point of sales system?
                </label>
                <div className="form-select-arrow">
                  <select
                    name={sfFields.posSystemType}
                    id={sfFields.posSystemType}
                  >
                    <option value="">--None--</option>
                    <option value="Wired">Wired</option>
                    <option value="Wireless">Wireless</option>
                  </select>
                </div>
              </div>
            )}
            {pointOfSales && (
              <div className="form-input-inner column-3 form-label-visible">
                <label for={sfFields.requireStaticIp}>
                  Does your point of sales system require a static IP Address?
                </label>
                <div className="form-select-arrow">
                  <select
                    name={sfFields.requireStaticIp}
                    id={sfFields.requireStaticIp}
                  >
                    <option value="">--None--</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            )}
            <div className="form-input-inner column-1 form-label-visible">
              <label for={sfFields.externalStaticIP}>
                Do you require an external static IP?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.externalStaticIP}
                  id={sfFields.externalStaticIP}
                >
                  <option value="">--None--</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <div className="form-input-inner column-1 form-label-visible">
              <label for={sfFields.siteToSiteVPN}>
                Do you operate a Site-to-site VPN?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.siteToSiteVPN}
                  id={sfFields.siteToSiteVPN}
                >
                  <option value="">--None--</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <div className="form-input-inner column-3 form-label-visible">
              <label for={sfFields.managedNetworkSwitch}>
                Do you have a managed network switch?
              </label>
              <div className="form-select-arrow">
                <select
                  name={sfFields.managedNetworkSwitch}
                  id={sfFields.managedNetworkSwitch}
                  onChange={(e) =>
                    setManagedNetworkSwitch(e.target.value === 'Yes')
                  }
                >
                  <option value="">--None--</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            {managedNetworkSwitch && (
              <div className="form-input-inner column-3 form-label-visible">
                <label for={sfFields.brandManagedNetworkSwitch}>
                  What brand of managed network switch do you have?
                </label>
                <input
                  type="text"
                  id={sfFields.brandManagedNetworkSwitch}
                  name={sfFields.brandManagedNetworkSwitch}
                  placeholder="Enter the brand"
                />
              </div>
            )}
          </div>
          <div className="form-button-container">
            <button className="square-button-yellow">Register</button>
          </div>
        </>
      )}
    </>
  );
};

export default BusinessMatchForm;
